import axios, { AxiosPromise } from 'axios';

import { IPackRelatedData } from '../../../@types/model/masterData/pack/packRelatedData';

export default class PackRelatedDataHttpService {
    public static getAllPackRelatedData() : AxiosPromise<IPackRelatedData> {
        return axios.get(`${API_URL}/v1/Pack/AllRelatedData`);
    }
}
